import React, { Component } from 'react';
import Header from '../layout/Header';
import { MDBProgress } from 'mdbreact';

export class Team_detail extends Component {
    render() {
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row-01">
                    <div className="container-xl">
                    <div className="row">
                        <div className="col-md-12"> 
                        <div className="title-box">
                            <div className="page-title-heading">
                            <h1 className="title">Team Details</h1>
                            </div>{/* /.page-title-captions */}
                            <div className="breadcrumb-wrapper">
                            <span>
                                <a title="Homepage" href={process.env.PUBLIC_URL + '/'}>Home</a>
                            </span>
                            <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                            <span>Team Details</span>
                            </div>  
                        </div>
                        </div>{/* /.col-md-12 */}  
                    </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}

                <section class="ttm-row team-detail-section clearfix">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="team-member-single-content pr-60 res-991-pr-0">
                                    <h3 class="team-member-single-title-h3">Jhon Martin</h3>
                                    <div class="team-member-single-category">Product Analyst</div>
                                    <p>Queen danio velvet catfish Sacramento blackfish, bullhead shark, Colorado squawfish Russian sturgeon clown triggerfish swamp-eel paradise fish. Hake cookie-cutter shark silver carp hawkfish snipe eel armorhead catfish, moray eel silverside! Bluegill toadfish, orangespine unicorn fish. Manta Ray Moorish idol moon sea robin: fierasfer, loach minnow southern Dolly Varden. South American darter pencilfish, "beluga sturgeon: walleye pollock," murray cod poolfish, "</p>
                                    <div class="educations-main">
                                        <h2 class="team-detail-h2">Educations</h2>
                                        <div>
                                            <h3 class="team-detail-h3">Gulinary school in Paris</h3>
                                            <ul class="team-detail-llist">
                                                <li class="team-detail-llist-item">
                                                <div class="team-detail-llist-text">2015 – 2018</div>
                                                </li>
                                            </ul>
                                            <p class="team-desc">Queen danio velvet catfish Sacramento blackfish, bullhead shark, Colorado squawfish Russian sturgeon clown triggerfish swamp-eel paradise fish. Hake cookie-cutter shark silver carp hawkfish snipe eel armorhead catfish, moray eel silverside! Bluegill toa</p>
                                        </div>
                                        <div class="mt-20 mb-30">
                                            <h3 class="team-detail-h3">Culinary University of Patagonia</h3>
                                            <ul class="team-detail-llist">
                                                <li class="team-detail-llist-item">
                                                <div class="team-detail-llist-text">2018 – 2019</div>
                                                </li>
                                            </ul>
                                            <p class="team-desc">Queen danio velvet catfish Sacramento blackfish, bullhead shark, Colorado squawfish Russian sturgeon clown triggerfish swamp-eel paradise fish. Hake cookie-cutter shark silver carp hawkfish snipe eel armorhead catfish, moray eel silverside! Bluegill toa</p>
                                        </div>
                                    </div>
                                    <div class="experiance-main">
                                        <h2 class="team-detail-h2">Experience</h2>
                                        <div>
                                            <h3 class="team-detail-h3">Asistants Senior Professors</h3>
                                            <ul class="team-detail-llist">
                                                <li class="team-detail-llist-item">
                                                <div class="team-detail-llist-text">2018 – 2020</div>
                                                </li>
                                            </ul>
                                            <p class="team-desc">Queen danio velvet catfish Sacramento blackfish, bullhead shark, Colorado squawfish Russian sturgeon clown triggerfish swamp-eel paradise fish. Hake cookie-cutter shark silver carp hawkfish snipe eel armorhead catfish, moray eel silverside! Bluegill toa</p>
                                        </div>
                                        <div class="mt-20">
                                            <h3 class="team-detail-h3">Asistants Senior Professors</h3>
                                            <ul class="team-detail-llist">
                                                <li class="team-detail-llist-item">
                                                <div class="team-detail-llist-text">2020 – 2022</div>
                                                </li>
                                            </ul>
                                            <p class="mb-0 team-desc" >Queen danio velvet catfish Sacramento blackfish, bullhead shark, Colorado squawfish Russian sturgeon clown triggerfish swamp-eel paradise fish. Hake cookie-cutter shark silver carp hawkfish snipe eel armorhead catfish, moray eel silverside! Bluegill toa</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="res-991-mt-30">
                                    <img width="417" height="503" class="img-fluid" src="images/team/team01.jpg" loading="lazy" alt="detail-img" />
                                    <div class="team-detail-main">
                                        <ul class="team-detail-list">
                                            <li class="team-detail-list-item">
                                            <div class="team-detail-list-text">Phone : </div>
                                            <div class="team-detail-list-text">
                                                <a href="tel:1234567890" class="team-detail-list-link pl-10"> +1800 200 14567</a>
                                            </div>
                                            </li>
                                            <li class="team-detail-list-item">
                                            <div class="team-detail-list-text">Email : </div>
                                            <div class="team-detail-list-text">
                                                <a href="mailto:info@example.com" class="team-detail-list-link pl-10"> info@example.com</a>
                                            </div>
                                            </li>
                                            <li class="team-detail-list-item">
                                            <div class="team-detail-list-text">Website : </div>
                                            <div class="team-detail-list-text">
                                                <a href="http://www.example.com" class="team-detail-list-link pl-10"> www.example.com</a>
                                            </div>
                                            </li>
                                        </ul>
                                        <ul class="team-detail-social-list">
                                            <li class="team-detail-list-item">
                                            <a href="#" class="team-detail-social-list-link"><i class="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li class="team-detail-list-item">
                                            <a href="#" class="team-detail-social-list-link"><i class="fab fa-twitter"></i></a>
                                            </li>
                                            <li class="team-detail-list-item">
                                            <a href="#" class="team-detail-social-list-link"><i class="fab fa-linkedin-in"></i></a>
                                            </li>
                                            <li class="team-detail-list-item">
                                            <a href="#" class="team-detail-social-list-link"><i class="fab fa-google-plus-g"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            )
    }
}


export default Team_detail;